<template>
  <default-template-message class="mb30">
    <div class="default-email-message-template">
      <div class="default-email-message-template__section">
        <email-message-template-text-area
          class="default-email-message-template__title"
          :class="{ 'error-input-border': hasGreetingError }"
          field-name="greeting"
          :value="templateData.greeting"
          :max-length="fieldsMaxLength.greeting"
          @field-input="onMarketingCampaignFieldInput"
          @field-change="onMarketingCampaignFieldChange"
        />

        <email-message-template-text-areas
          class="default-email-message-template__paragraph"
          :body-error="hasBodyError"
          :textarea-bindings="textareaBindings"
          @field-input="onMarketingCampaignFieldInput"
          @field-change="onMarketingCampaignFieldChange"
        />
      </div>

      <email-message-template-link-section :link-name="templateData.linkName" />

      <email-message-template-signature-section :template-data="templateData" />
    </div>
  </default-template-message>
</template>

<script>
import DefaultTemplateMessage from '@/modules/dashboard/components/message-templates/common/DefaultTemplateMessage';
import EmailMessageTemplateTextArea from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextArea';
import EmailMessageTemplateSignatureSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateSignatureSection';
import EmailMessageTemplateLinkSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateLinkSection';
import EmailMessageTemplateTextAreas from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextAreas';

import { getExistingFieldsTextareaBindings } from '@/modules/dashboard/utils';

export default {
  name: 'EmailMarketingMessageTemplate',
  components: {
    EmailMessageTemplateLinkSection,
    EmailMessageTemplateSignatureSection,
    EmailMessageTemplateTextArea,
    EmailMessageTemplateTextAreas,
    DefaultTemplateMessage
  },
  inject: ['$validator'],
  props: {
    templateData: {
      type: Object,
      required: true
    },
    fieldsMaxLength: {
      type: Object,
      required: true
    },
    templateErrors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    textareaBindings() {
      return getExistingFieldsTextareaBindings({
        fields: ['bodyPartOne', 'bodyPartTwo', 'bodyPartThree'],
        templateData: this.templateData,
        fieldsMaxLength: this.fieldsMaxLength
      });
    },
    hasGreetingError() {
      return this.templateErrors.greeting;
    },
    hasBodyError() {
      return this.templateErrors.bodyPartOne;
    }
  },
  methods: {
    onMarketingCampaignFieldInput(eventValue) {
      this.$emit('field-input', eventValue);
    },
    onMarketingCampaignFieldChange(eventValue) {
      this.$emit('field-change', eventValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/message-templates/email-message-templates';
@import '../../../../../assets/scss/helpers/colors';
@import '../../../../../assets/css/common/errors';
</style>
